import { defineTextStyles } from "@chakra-ui/react"

export const textStyles = defineTextStyles({
  regular12: {
    value: {
      fontFamily: "Helvetica, sans-serif",
      fontWeight: "400",
      fontSize: "12px",
      lineHeight: "20px",
      letterSpacing: "0",
      textDecoration: "None",
      textTransform: "lowercase",
    },
  },
  regular14: {
    value: {
      fontFamily: "Helvetica, sans-serif",
      fontWeight: "400",
      fontSize: "14px",
      lineHeight: "24px",
      letterSpacing: "0",
      textDecoration: "None",
      textTransform: "lowercase",
    },
  },
  regular16: {
    value: {
      fontFamily: "Helvetica, sans-serif",
      fontWeight: "400",
      fontSize: "16px",
      lineHeight: "20px",
      letterSpacing: "0",
      textDecoration: "None",
      textTransform: "lowercase",
    },
  },
  regular24: {
    value: {
      fontFamily: "Helvetica, sans-serif",
      fontWeight: "400",
      fontSize: "24px",
      lineHeight: "20px",
      letterSpacing: "0",
      textDecoration: "None",
      textTransform: "lowercase",
    },
  },
  regularDel24: {
    value: {
      fontFamily: "Helvetica, sans-serif",
      fontWeight: "400",
      fontSize: "24px",
      lineHeight: "20px",
      letterSpacing: "0",
      textDecoration: "line-through",
      textTransform: "lowercase",
    },
  },
  regularDel12: {
    value: {
      fontFamily: "Helvetica, sans-serif",
      fontWeight: "400",
      fontSize: "12px",
      lineHeight: "20px",
      letterSpacing: "0",
      textDecoration: "line-through",
      textTransform: "lowercase",
    },
  },
  medium15: {
    value: {
      fontFamily: "Helvetica Neue, sans-serif",
      fontWeight: "500",
      fontSize: "15px",
      lineHeight: "20px",
      letterSpacing: "0.4px",
      textDecoration: "None",
      textTransform: "lowercase",
    },
  },
  medium16: {
    value: {
      fontFamily: "Helvetica Neue, sans-serif",
      fontWeight: "500",
      fontSize: "16px",
      lineHeight: "20px",
      letterSpacing: "0.4px",
      textDecoration: "None",
      textTransform: "lowercase",
    },
  },
  medium20: {
    value: {
      fontFamily: "Helvetica Neue, sans-serif",
      fontWeight: "500",
      fontSize: "20px",
      lineHeight: "100%",
      letterSpacing: "0",
      textDecoration: "None",
      textTransform: "lowercase",
    },
  },
  bold12: {
    value: {
      fontFamily: "Helvetica, sans-serif",
      fontWeight: "700",
      fontSize: "12px",
      lineHeight: "20px",
      letterSpacing: "0",
      textDecoration: "None",
      textTransform: "lowercase",
    },
  },
  bold14: {
    value: {
      fontFamily: "Helvetica, sans-serif",
      fontWeight: "700",
      fontSize: "14px",
      lineHeight: "20px",
      letterSpacing: "0",
      textDecoration: "None",
      textTransform: "lowercase",
    },
  },
  bold16: {
    value: {
      fontFamily: "Helvetica, sans-serif",
      fontWeight: "700",
      fontSize: "16px",
      lineHeight: "20px",
      letterSpacing: "0",
      textDecoration: "None",
      textTransform: "lowercase",
    },
  },
  bold18: {
    value: {
      fontFamily: "Helvetica, sans-serif",
      fontWeight: "700",
      fontSize: "18px",
      lineHeight: "100%",
      letterSpacing: "0",
      textDecoration: "None",
      textTransform: "lowercase",
    },
  },
  bold20: {
    value: {
      fontFamily: "Helvetica, sans-serif",
      fontWeight: "700",
      fontSize: "20px",
      lineHeight: "100%",
      letterSpacing: "0",
      textDecoration: "None",
      textTransform: "lowercase",
    },
  },
  bold24: {
    value: {
      fontFamily: "Helvetica, sans-serif",
      fontWeight: "700",
      fontSize: "24px",
      lineHeight: "24px",
      letterSpacing: "0",
      textDecoration: "None",
      textTransform: "lowercase",
    },
  },
  bold32: {
    value: {
      fontFamily: "Helvetica, sans-serif",
      fontWeight: "700",
      fontSize: "32px",
      lineHeight: "100%",
      letterSpacing: "0",
      textDecoration: "None",
      textTransform: "lowercase",
    },
  },
  bold56: {
    value: {
      fontFamily: "Helvetica, sans-serif",
      fontWeight: "700",
      fontSize: "56px",
      lineHeight: "56px",
      letterSpacing: "0",
      textDecoration: "None",
      textTransform: "lowercase",
    },
  }
})